module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-edit-parking-group"
  }, [_c('modal-reveal', {
    ref: "modalEditPG",
    attrs: {
      "sizing": "small"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]), _c('h2', [_vm._v("Edit Parking Group - " + _vm._s(_vm.item.name))]), _c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  })]), _c('BookingModeSelect', {
    model: {
      value: (_vm.item.reservation_type),
      callback: function($$v) {
        _vm.$set(_vm.item, "reservation_type", $$v)
      },
      expression: "item.reservation_type"
    }
  }), _c('label', [_vm._v("Vat"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vat_id),
      expression: "vat_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vat_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select custom vat")]), _vm._l((_vm.vats), function(vat) {
    return _c('option', {
      domProps: {
        "value": vat.id
      }
    }, [_vm._v(_vm._s(vat.description) + " (" + _vm._s(vat.name) + " " + _vm._s(vat.percentage) + "%)")])
  })], 2)]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-96354058!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/asset-management/EditParkingGroup.vue
// module id = 2641
// module chunks = 1